"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "quarrata": {
    "6c0f50f1": [{
      "hkey": "1f96c20e",
      "slug": "quarrata",
      "name": "Quarrata",
      "primary": true,
      "skipSearch": false
    }],
    "buciano": [{
      "hkey": "1f96c20e",
      "slug": "quarrata",
      "name": "Quarrata",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0d604f1e": [{
      "hkey": "1f96c20e",
      "slug": "quarrata",
      "name": "Quarrata",
      "primary": true,
      "skipSearch": false
    }],
    "campiglio": [{
      "hkey": "1f96c20e",
      "slug": "quarrata",
      "name": "Quarrata",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "805d9e5f": [{
      "hkey": "1f96c20e",
      "slug": "quarrata",
      "name": "Quarrata",
      "primary": true,
      "skipSearch": false
    }],
    "case-gori": [{
      "hkey": "1f96c20e",
      "slug": "quarrata",
      "name": "Quarrata",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8b26a3bb": [{
      "hkey": "1f96c20e",
      "slug": "quarrata",
      "name": "Quarrata",
      "primary": true,
      "skipSearch": false
    }],
    "dreoni": [{
      "hkey": "1f96c20e",
      "slug": "quarrata",
      "name": "Quarrata",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "89894a0a": [{
      "hkey": "b6db64ba",
      "slug": "vignole-olmi",
      "name": "Vignole-Olmi",
      "primary": true,
      "skipSearch": false
    }],
    "olmi": [{
      "hkey": "b6db64ba",
      "slug": "vignole-olmi",
      "name": "Vignole-Olmi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "quarrata"
    }],
    "b08bcdc4": [{
      "hkey": "7b4a43c2",
      "slug": "pontassio-rubattorno",
      "name": "Pontassio-Rubattorno",
      "primary": true,
      "skipSearch": false
    }],
    "pontassio": [{
      "hkey": "7b4a43c2",
      "slug": "pontassio-rubattorno",
      "name": "Pontassio-Rubattorno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "3f1602bb": [{
      "hkey": "7b4a43c2",
      "slug": "pontassio-rubattorno",
      "name": "Pontassio-Rubattorno",
      "primary": true,
      "skipSearch": false
    }],
    "rubattorno": [{
      "hkey": "7b4a43c2",
      "slug": "pontassio-rubattorno",
      "name": "Pontassio-Rubattorno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "quarrata"
    }],
    "d9b45cf9": [{
      "hkey": "b6db64ba",
      "slug": "vignole-olmi",
      "name": "Vignole-Olmi",
      "primary": true,
      "skipSearch": false
    }],
    "vignole": [{
      "hkey": "b6db64ba",
      "slug": "vignole-olmi",
      "name": "Vignole-Olmi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;